import PrivacyPolicyIntroductionPage from './PrivacyPolicyIntroductionPage';
export type { PrivacyPolicyIntroductionPageProps } from './PrivacyPolicyIntroductionPage.types';

export { PrivacyPolicyIntroductionPage };
